import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Bargainlist from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface BargainState extends ListState<Bargainlist> {
    editSeckilllist: Bargainlist;
}
class BargainModule extends ListModule<BargainState, any, Bargainlist> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Bargainlist>(),
        loading: false,
        editTemplate: new Bargainlist(),
        bargainVersion: 0,
        bargainProductInfo: [],
        bargainActInfo: [],
        limitedVersion: 0,
        limitedProductInfo: [],
        limitedActInfo: [],
    };
    public actions = {
        async getAll(context: ActionContext<BargainState, any>, payload: any) {
            context.state.loading = true;
            const reponse = await Ajax.get('/api/services/app/BuyLimit/GetBuyLimitList', { params: payload.data });
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Bargainlist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    public mutations = {
        setState(state, payload) {
            for (let key in payload) {
                state[key] = payload[key]
            }
        },
        setCurrentPage(state: BargainState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BargainState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: BargainState, Bargainlist: Bargainlist) {
            state.editSeckilllist = Bargainlist;
        },
    };
}
const bargainModule = new BargainModule();
export default bargainModule;
